import { Conversation } from "@gumtree/shared/src/types/message-centre";

const getUnreadMessagesCount = (conversations: Conversation[]): number => {
  if (Array.isArray(conversations)) {
    return conversations.reduce((total, { unreadMessagesCount }) => total + unreadMessagesCount, 0)
  }

  return 0;
};

export default getUnreadMessagesCount;
